module.exports = __webpack_public_path__ + "static/img/fingerpost_express_5.84e6aad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fingerpost/fingerpost_express_5.jpg
// module id = Ddxc
// module chunks = 0